import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { PaginatedResponse } from '../types/api';
import type {
  PartnerReferralCodeSubscription,
} from '../types/partnerReferralCode';
import { partnerReferralCodeQueryKeys } from './usePartnerReferralCodes';

type PartnerReferralCodeSubscriptionsResponse = PaginatedResponse<
  PartnerReferralCodeSubscription[]
>;

type DefaultError = unknown;

type UsePartnerReferralCodeSubscriptionsParams = {
  id: string;
  searchParams?: Record<string, any>;
  enabled?: boolean;
};

export function usePartnerReferralCodeSubscriptions<
  TData = PartnerReferralCodeSubscriptionsResponse,
  TError = DefaultError,
>(
  {
    id,
    searchParams = {},
    enabled = true,
  }: UsePartnerReferralCodeSubscriptionsParams,
  options?: Omit<
    UseQueryOptions<
      PartnerReferralCodeSubscriptionsResponse,
      TError,
      TData,
      QueryKey
    >,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  return useQuery<PartnerReferralCodeSubscriptionsResponse, TError, TData>({
    queryKey: partnerReferralCodeQueryKeys.subscriptions(id, searchParams),
    enabled: enabled && !!id,
    queryFn: async () =>
      service.getPartnerReferralCodeSubscriptions(id, searchParams),
    ...(options as any),
  });
}
